import { Box, Typography } from "@mui/material";
import { vibrant } from "@repo/dashboard-constants";

interface ValidationMessageProps {
  message: string;
}

export const ValidationMessage = ({ message }: ValidationMessageProps) => {
  return (
    <Box
      sx={{
        p: 1,
        backgroundColor: vibrant[800],
        border: `1px solid ${vibrant[600]}`,
        borderRadius: 3,
        mt: 1,
        mb: 1,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: "#ef5350 !important",
          fontSize: "0.875rem",
          letterSpacing: "1px",
          fontWeight: 600,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};
